module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/19A6gFX/tc-custom/9780802191748.jpg?1708749928245",
      "alt": "This image is the cover for the book Stranded"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Stranded\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A must-read collection of stories by Scottish crime writer Val McDermid, “one of the bright lights of the mystery field” ("), _c('i', [_vm._v("The ")])]), _c('b', [_c('i', [_vm._v("Washington Post")])]), _c('b', [_vm._v(").")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Val McDermid’s novels have won the Los Angeles Times Book of the Year Award and the Crime Writers’ Association’s Gold Dagger and Cartier Diamond Dagger Award for outstanding achievement. Enjoyed by millions of fans worldwide, her intelligent, incisive crime fiction showcases the best and worst of human nature. Here it is now, distilled into a superb collection of nineteen nail-biting, perfectly plotted short stories, including two featuring private eye Kate Brannigan and a foreword by Ian Rankin."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" “McDermid is as smooth a practitioner of crime fiction as anyone out there . . . She’s the best we’ve got.” —"), _c('i', [_vm._v("The New York Times Book Review")])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Val McDermid, Ian Rankin\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Val McDermid is the author of twenty-five previous best-selling novels, which have been translated into over forty languages and have sold over ten million copies worldwide.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Grove / Atlantic, Inc.\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0